<template>
  <div class="find-password">
    <div class="find-password-wrap">
      <div class="title">找回密码</div>
      <a-steps progress-dot :current="current">
        <a-step title="验证用户" />
        <a-step title="设置密码" />
        <a-step title="完成" />
      </a-steps>
      <a-form-model
        :model="form"
        ref="findPassword"
        :rules="rules"
        :label-col="{ span: 4, offset: 2 }"
        :wrapper-col="{ span: 14 }"
      >
        <template v-if="current === 0">
          <a-form-model-item label="用户名" prop="account">
            <a-input
              v-model="form.account"
              placeholder="请输入用户名"
              size="large"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="手机号" prop="phone">
            <a-input
              v-model="form.phone"
              placeholder="请输入手机号"
              size="large"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="验证码" prop="code">
            <a-col :span="14">
              <a-input
                v-model="form.code"
                placeholder="请输入验证码"
                size="large"
              ></a-input>
            </a-col>
            <a-col :span="8" :offset="1">
              <a-button
                :disabled="disabled"
                type="primary"
                ghost
                @click="setCode"
              >
                {{ text }}
              </a-button>
            </a-col>
          </a-form-model-item>
        </template>
        <template v-if="current === 1">
          <a-form-model-item label="新密码" prop="newPass">
            <a-input-password
              v-model="form.newPass"
              placeholder="请输入新密码"
              size="large"
            ></a-input-password>
          </a-form-model-item>
          <a-form-model-item label="确认密码" prop="confirmPass">
            <a-input-password
              v-model="form.confirmPass"
              placeholder="请再次输入密码"
              size="large"
            ></a-input-password>
          </a-form-model-item>
        </template>
        <div v-if="current === 2" class="complete">密码重置成功</div>
        <a-form-model-item class="btn">
          <a-button type="primary" @click="goLogin">
            返回登录页面
          </a-button>

          <!--          <a-button
                      type="primary"
                      v-if="current !== 0 && current !== 2"
                      @click="prevEvent"
                    >
                      上一步
                    </a-button>-->
          <a-button type="primary" v-if="current !== 2" @click="nextEvent">
            {{ nextName }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import hexMd5 from "js-md5";

const pwdAgainCheck = (rule, value, callback) => {
  if (value !== this.form["newPass"]) {
    callback(new Error("两次输入密码不一致"));
    return;
  }
  callback();
};

const phoneCheck = (rules, value, callback) => {
  if (
    !/^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/.test(
      value
    )
  ) {
    callback(new Error("手机号码输入有误"));
    return;
  }
  callback();
};

const passCheck = (rules, value, callback) => {
  if (
    !/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[#\-%_!@$&*])[\da-zA-Z#\-%_!@$&*]{8,}$/.test(
      value
    )
  ) {
    callback(
      new Error(
        "8位以上数字、字母和特殊符号组合（特殊字符请从“#、%、*、-、_ 、!、@、$、&”中选取）"
      )
    );
    return;
  }
  callback();
};
export default {
  name: "FindPassword",
  data() {
    return {
      form: {},
      current: 0,
      text: "获取验证码",
      disabled: false,
      times: 60,
      nextName: "下一步",
      token: "",
      rules: {
        account: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur"]
          },
          { validator: phoneCheck, trigger: ["blur"] }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"]
          }
        ],
        newPass: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"]
          },
          { validator: passCheck, trigger: ["blur", "change"] }
        ],
        confirmPass: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"]
          },
          { validator: pwdAgainCheck, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  methods: {
    setCode() {
      if (!this.form["account"] || !this.form["phone"]) {
        this.$message.error("请填写用户名和手机号。");
        return;
      }
      const params = {
        userName: this.form["account"],
        mobile: this.form["phone"]
      };

      this.$json("forgetPassSendSms", params).then(res => {
        if (res.code) {
          this.$message.error("用户名或手机号码错误。");
        } else {
          this.disabled = true;
          this.countDown(60);
          this.$message.success("验证码已发送，请注意查收");
        }
      }).catch(e => {
        if(e.message){
          this.$message.error(e.message);
        }
      });
    },
    countDown(times) {
      this.times = times;
      const timer = setInterval(() => {
        this.times--;
        this.text = `重新发送(${this.times})`;
        if (this.times === 0) {
          this.disabled = false;
          this.text = "重新发送";
          clearInterval(timer);
        }
      }, 1000);
    },
    prevEvent() {
      if (this.current !== 0) {
        this.current -= 1;
        this.nextName = this.current === 1 ? "提交" : "下一步";
      }
    },
    goLogin() {
      this.$router.push({ name: "Login" });
    },
    nextEvent() {
      this.$refs.findPassword.validate(valid => {
        if (valid) {
          // 下一步事件

          // 提交事件
          if (this.current === 2) {
            // 提交密码成功2秒后返回登录页面
            setTimeout(() => {
              this.$router.push("/");
            }, 2000);
          }
          // this.current += 1;
          this.nextName = this.current === 1 ? "提交" : "下一步";
        }
      });
      if (this.current === 0) {
        const params = {
          userName: this.form["account"],
          mobile: this.form["phone"],
          code: this.form["code"]
        };
        this.$json("forgetPassVerificationSms", params).then(res => {
          if (res.code) {
            this.$message.error(res.message);
          } else {
            this.token = res.data;
            this.$message.success("验证码通过，请重置密码");
            this.current += 1;

            this.nextName = this.current === 1 ? "提交" : "下一步";
          }
        });
      } else if (this.current === 1) {
        const params = {
          userName: this.form["account"],
          token: this.token,
          password: hexMd5(this.form["newPass"])
        };
        this.$json("forgetPassResetPass", params).then(res => {
          if (res.code) {
            this.$message.error(res.message);
          } else {
            this.$message.success("密码修改成功，可以重新登录");
            this.current += 1;
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.find-password {
  height: 100%;
  //background: url("../assets/logleft2560.jpg") no-repeat;
  background: url("../assets/Login-banner.png") no-repeat;
  background-size: 100% 100%;

  .find-password-wrap {
    position: relative;
    top: 50%;
    width: 500px;
    margin: 0 auto;
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 8px #c1c1c1;
    transform: translateY(-50%);

    .title {
      font-size: 18px;
      margin-bottom: 20px;
      text-align: center;
    }

    .ant-steps {
      margin-bottom: 20px;
    }

    .btn {
      margin-bottom: 0;
      text-align: center;

      /deep/ .ant-col {
        width: 100%;
      }

      .ant-btn {
        &:not(:last-child) {
          margin-right: 15px;
        }
      }
    }

    .complete {
      font-size: 20px;
      color: #1890ff;
      text-align: center;
      line-height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/findPassword.vue